import React from "react";
import { Upload, message } from "antd";

import { PlusOutlined } from "@ant-design/icons";
// import { getOssConfigApi } from "@/fetch/fetchApi";

// import contextApi from "@/utils/contextApi";
import { randomString, getSuffix } from "./utils";
import styles from "./index.less";

// 通用上传组件
class UploadGeneral extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fileList: [],
      fileUrlMap: [],
      ossConfig: {},
      uploadButton: props.children || (
        <div>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>上传</div>
        </div>
      ),
      uploadProps: {
        listType: "text",
        // ...restProps,
        name: "file",
        // action: "//www.mocky.io/v2/5cc8019d300000980a055e76",
        // onPreview: handlePreview,
        onChange: this.handleChange,
        // onRemove: handleRemove,
        beforeUpload: this.beforeUpload,
      },
    };
  }

  initUploadProp = async () => {
    const uploadProps = this.getUploadProps();
    this.setState({ uploadProps: uploadProps });
  };

  setUploadParmas = async (file) => {
    const { ossConfig } = this.state;
    const bufferSencond = 3;
    const now = Date.parse(new Date()) / 1000;
    if (ossConfig.expire && ossConfig.expire - bufferSencond > now) {
      this.setState({
        ossConfig: {
          ...ossConfig,
          //   key: this.calculateFileName(ossConfig.host, ossConfig.dir, file),
        },
      });
      return true;
    }
    //   const resall = await getOssConfigApi();
    //   const res = resall.data;

    //   if (res.code === "200") {
    //       const config = { ...res.data };
    //       config.OSSAccessKeyId = config.accessId;
    //       delete config.accessId;
    //       config.key = this.calculateFileName(config.host, config.dir, file);
    //       this.setState({
    //           ossConfig: {
    //               ...ossConfig,
    //               ...config,
    //           },
    //       });
    //       return true;
    //   } else {
    //       // contextApi("message").error("请求上传配置失败");
    //       message.error("请求上传配置失败");
    //       return false;
    //   }
  };

  //   calculateFileName = (host, path, file) => {
  //     const prefixFile = sessionStorage.getItem("prefixFile");
  //     const { fileUrlMap } = this.state;
  //     const suffix = getSuffix(file.name);
  //     const fileName = randomString(10) + suffix;
  //     const fileNameWithPath = path + fileName;
  //     this.setState({
  //       fileUrlMap: [...fileUrlMap, { uid: file.uid, url: `${prefixFile}/${fileNameWithPath}` }],
  //     });
  //     return fileNameWithPath;
  //   };

  getPathAfterDomain = (url) => {
    try {
      // 用原生URL对象解析，自动处理各种复杂情况
      const parsedUrl = new URL(url);
      // pathname: 路径部分（如 /path/to/file）
      // search: 查询参数（如 ?name=test）
      // hash: 哈希值（如 #hash）
      // 2. 拼接路径+查询参数+哈希
      const fullPath = parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
      // 3. 排除第一个斜杠（如果存在）
      return fullPath.startsWith("/") ? fullPath.slice(1) : fullPath;
    } catch (error) {
      console.error("URL格式错误:", error);
      return ""; // 解析失败返回空字符串
    }
  };

  handleChange = (info) => {
    // console.log("handleChange", info);
    if (info.fileList.length > 1) {
      this.setState({ fileList: [info.fileList[info.fileList.length - 1]] });
    } else {
      this.setState({ fileList: info.fileList });
    }

    if (info.file.status === "done") {
      this.triggleFormOnChange(info.fileList);
      if (this.props.getKey) {
        const fileResponse = info.file.response.data;
        const { url } = fileResponse[0];
        this.props.getKey(this.getPathAfterDomain(url));
      }
    }
  };

  triggleFormOnChange = async (newFileList) => {
    const { onChange, lightMode } = this.props;
    const { fileUrlMap } = this.state;
    // console.log("triggleFormOnChange", "newFileList:", newFileList, "fileUrlMap:", fileUrlMap);
    if (onChange) {
      let copyFileList = [...newFileList];
      copyFileList.forEach((item) => {
        // console.log("item:", item);
        if (!item.fileUrl) {
          const match = fileUrlMap.find((mapitem) => mapitem.uid === item.uid);
          if (match) {
            item.fileUrl = match.fileUrl;
          }
        }
      });
      copyFileList = copyFileList.map((item) => {
        // console.log("item11:", item);
        return {
          size: item.size,
          type: item.type,
          uid: item.uid,
          name: item.name,
          //   url: item.fileUrl,
          url: item.response.data[0].url,
          extra: item.extra || {},
        };
      });
      if (lightMode) {
        onChange(copyFileList[copyFileList.length - 1]);
      } else {
        onChange(copyFileList);
      }
    }
  };

  beforeUpload = async (file) => {
    const configOk = await this.setUploadParmas(file);
    const uploadProps = this.getUploadProps();
    this.setState({ uploadProps: uploadProps });
    if (this.props.bf) {
      const res2 = this.props.bf(file);
      return configOk && res2;
    }
    return configOk;
  };

  getUploadProps = () => {
    const { host, expire, ...requestExtraParams } = this.state.ossConfig;
    const prefixFile = sessionStorage.getItem("prefixFile");
    // console.log(prefixFile, "prefixFile");
    // debugger;

    return {
      listType: "text",
      // ...restProps,
      name: "files[]",
      // action: "//www.mocky.io/v2/5cc8019d300000980a055e76",
      action: `${prefixFile}/filesUpload.do`,
      //   data: requestExtraParams,
      headers: {
        Authorization: sessionStorage.getItem("token"),
      },
      // onPreview: handlePreview,
      onChange: this.handleChange,
      //   customRequest: this.handleChange,
      // onRemove: handleRemove,
      beforeUpload: this.beforeUpload,
    };
  };

  render() {
    const { lightMode = false } = this.props;
    const { uploadButton, uploadProps, fileList } = this.state;
    const mainClassName = `${styles.ossUpload} ${lightMode ? styles.noPreview : ""}`;
    return (
      <div className={mainClassName}>
        <Upload {...uploadProps} fileList={fileList} maxCount={1}>
          {uploadButton}
        </Upload>
      </div>
    );
  }
}

export default UploadGeneral;



// WEBPACK FOOTER //
// ./src/AntD/components/display/upload/OssUpload/index.js